import {useMemo} from 'react';
import {useReservation} from 'context/reservation';
import {useGuestGroup} from 'hooks';
import {usePhoneParser} from './usePhoneParser';

export function useDefaultContactData() {
  const {data: reservation} = useReservation();
  const {guestGroup} = useGuestGroup();
  const {parsePhoneNumber} = usePhoneParser();

  const defaultContactData = useMemo(() => {
    const defaultEmail = reservation?.default_invite_email;
    const defaultPhone = reservation?.default_phone_number;
    const isLeadVerified = !!guestGroup?.is_leader_contact_verified;
    const isLeaderGuest = !guestGroup?.added_number_of_guests;
    const parsedPhone = defaultPhone
      ? parsePhoneNumber(defaultPhone)
      : {code: '', number: ''};

    return {
      email: defaultEmail || '',
      phone: parsedPhone,
      isLeadVerified,
      isLeaderGuest,
    };
  }, [reservation, guestGroup, parsePhoneNumber]);

  return defaultContactData;
}
